export const endpoints = {
  getLLMSuggestionsGiftMessage: () => '/dashboard/llm-suggestions/gift-message',
  getLLMSuggestionsProductFilters: () => '/dashboard/llm-suggestions/product-filters'
};
